import { render } from "./OffersPage.vue?vue&type=template&id=f89d2dd0&scoped=true"
import script from "./OffersPage.vue?vue&type=script&lang=js"
export * from "./OffersPage.vue?vue&type=script&lang=js"

import "./OffersPage.vue?vue&type=style&index=0&id=f89d2dd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89d2dd0"]])

export default __exports__